import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux';
import { setVideoUploadDialogOpen } from '../../redux/reducers/loginSlice';
import Upload from '../upload/Upload';

function UploadVideoModelComponent() {
  const dispatch = useDispatch();
  const isUploadDialogOpen = useSelector((state) => state.login.isVideoUploadDialogOpen);

  const handleClose = () => {
    dispatch(setVideoUploadDialogOpen(false));
  };

  return (
    <Dialog
      open={isUploadDialogOpen}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '95vh',
          overflow: 'auto',
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        <Upload onUploadComplete={handleClose} />
      </DialogContent>
    </Dialog>
  );
}

export default UploadVideoModelComponent;
